export enum SquirrelResultFormatType
{
    Markdown = "Markdown",
    HTML = "HTML",
}